import { cn } from './cn.js';

import type { ReactElement, ReactNode } from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

interface GlassBadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
  dot?: boolean;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-[var(--glass-bg-strong)] text-text-secondary border-[var(--glass-border-subtle)]',
  success: 'bg-success-soft text-success-fg border-success/20',
  warning: 'bg-warning-soft text-warning-fg border-warning/20',
  danger: 'bg-danger-soft text-danger-fg border-danger/20',
  info: 'bg-info-soft text-info-fg border-info/20',
};

const dotColors: Record<BadgeVariant, string> = {
  default: 'bg-text-tertiary',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
  info: 'bg-info',
};

export function GlassBadge({
  variant = 'default',
  children,
  className,
  dot,
}: GlassBadgeProps): ReactElement {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium',
        'border backdrop-blur-sm',
        variantClasses[variant],
        className,
      )}
    >
      {dot === true && <span className={cn('w-1.5 h-1.5 rounded-full', dotColors[variant])} />}
      {children}
    </span>
  );
}
